import { UserRole } from "@next-platform/packages-ts-types";
import { APPLICATIONS_ID } from "../../../infra/constants/domains";
import { SubscriptionTiers, UserRoles } from "../types";
/**
 * Maps a CMS inference-model `level` to the UserRole whose plan name should
 * be shown on model-selection badges.
 *
 * Display only. Grouping, gating, and badge colors must keep using the raw
 * CMS `level` string (e.g. SubscriptionTiers.PREMIUM = "I'm All In").
 */
const getModelTierDisplayRole = ({ level, applicationId }) => {
    if (!level) {
        return null;
    }
    const normalizedLevel = level.toLowerCase();
    const isSecretMate = applicationId === APPLICATIONS_ID.SecretMate;
    if (normalizedLevel === SubscriptionTiers.PREMIUM.toLowerCase()) {
        return isSecretMate ? UserRole.SM_PREMIUM : UserRoles.PREMIUM;
    }
    if (normalizedLevel === SubscriptionTiers.BASIC.toLowerCase()) {
        return isSecretMate ? UserRole.SM_BASIC : UserRoles.BASIC;
    }
    if (normalizedLevel === SubscriptionTiers.MINIMAL.toLowerCase()) {
        return UserRoles.MINIMAL;
    }
    return null;
};
export default getModelTierDisplayRole;
